import React from 'react';
import withAppState from '../../../mobx/withAppState'
import { Steps } from '../../../lib/constants';
import PaymentConfirmation from '../../../components/PaymentConfirmation';

const MiPayAtTablePaymentConfirmationWrapper = (props) => {
  const handleGoToRegister = () => {
    props.goToStep(Steps.REGISTER);
    props.setPostRegisterAction(() => window.location = "https://www.pizzaexpress.com/");
  }

  const handleBackToBillsButton = () => {
    props.updateBillTotalAndSplit();
    props.resetToBillStepPayAtTable();
    props.startRefreshBillCycle();
  }

  return <PaymentConfirmation
    handleGoToRegister={handleGoToRegister}
    handleBackToBillsButton={handleBackToBillsButton}
    canSignup={props.getCanSignup()}
    hasSocialLinks={props.getHasSocialLinks()}
    companyName={props.getCompanyName()}
    returnHref={props.getReturnHref()}
    applySoftOptIn = {props.getApplySoftOptIn()} />
}

export default withAppState(MiPayAtTablePaymentConfirmationWrapper,
  {
    mobXActions: ({
      goToStep,
      setPostRegisterAction,
      resetToBillStepPayAtTable,
      updateBillTotalAndSplit,
      startRefreshBillCycle,
      getCanSignup,
      getHasSocialLinks,
      getCompanyName,
      getReturnHref,
      getApplySoftOptIn
    }) => ({
      goToStep,
      setPostRegisterAction,
      updateBillTotalAndSplit,
      resetToBillStepPayAtTable,
      startRefreshBillCycle,
      getCanSignup,
      getHasSocialLinks,
      getCompanyName,
      getReturnHref,
      getApplySoftOptIn
    }),
    mobXProps: ({
      bill,
      gratuityTotal,
      billTotal,
      billTotalWhenPaying
    }) => ({
      bill,
      gratuityTotal,
      billTotal,
      billTotalWhenPaying
    })
  }
);